import { Observable } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { Actions } from 'src/core/state/cart/coupon';
import { scrollTop } from 'src/core/engine/runtime/utils/scrollTop';
import { map } from 'rxjs';

export function scrollTopAfterCoupon(action$: Observable<any>): Observable<any> {
    return action$.pipe(
        ofType<Actions>('Coupon.ApplySuccess', 'Coupon.DeleteSuccess'),
        map(() => scrollTop()),
    );
}
